<template>
  <div>
    <div class="row-width-actions-bar is-border-bottom">
      <div class="columns is-gapless">
        <div v-if="canDrag" class="column is-narrow is-border-right">
          <button class="page-header-btn is-small is-square has-cursor-grab"><span class="icon is-size-4"><i
            class="fal fa-grip-lines"></i></span></button>
        </div>
        <div class="column is-padding-left-small is-self-centered columns is-gapless is-vcentered">
          <div class="column is-narrow">
            <div class="dot is-medium has-text-white is-margin-right-small"
                 :class="documentIsValid ? 'has-bg-success' : 'is-border'">
              <i class="fal fa-check is-size-6" v-if="documentIsValid"></i>
            </div>
          </div>
          <div class="column">
            <a v-if="documentIsValid && (isAdmin || isSectorManager || item.document.display)" @click="openPreview(item.document)" class="is-fullwidth is-size-6 is-underline">{{item.name}}</a>
            <span v-else-if="!(isAdmin || isSectorManager) && documentIsValid" class="is-fullwidth is-size-6">{{item.name}}</span>
            <input v-else-if="isAdmin || isSectorManager" class="input is-borderless is-small is-fullwidth" v-model="item.name"
                   @click="$event.target.select()" @input="updateName">
            <span v-else class="is-fullwidth is-size-6 ">{{item.name}}</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left" v-if="!askRemoveLink && documentIsValid && (isAdmin || isSectorManager)">
          <a v-if="!askRemoveLine" class="page-header-btn is-small is-square tooltip is-tooltip-top"
             data-tooltip="Supprimer document lié" @click="askRemove('askRemoveLink')">
            <span class="icon is-size-4"><i class="fal fa-unlink"></i></span>
          </a>
          <a v-else class="page-header-btn is-small is-square tooltip is-tooltip-top"
             data-tooltip="Supprimer document lié" :disabled="true">
            <span class="icon is-size-4"><i class="fal fa-unlink"></i></span>
          </a>
        </div>
        <div class="column is-narrow is-border-left" v-else-if="!askRemoveLink && !documentIsValid && (isAdmin || isSectorManager)">
          <a v-if="!askRemoveLine && !openInput" class="page-header-btn is-small is-square tooltip is-tooltip-top"
             @click="openModalDocumentsSelection(item.value)" data-tooltip="Lier un document">
            <span class="icon is-size-4"><i class="fal fa-link"></i></span>
          </a>
          <label v-else-if="!askRemoveLine && openInput"
                 class="page-header-btn is-small is-square tooltip is-tooltip-top" data-tooltip="Lier un document">
            <input class="file-input" type="file" accept='image/png, image/jpeg, .pdf' @change="processFile($event)"
                   name="resume">
            <span v-if="!uploading" class="is-marginless icon is-size-4"><i class="fal fa-link"></i></span>
            <span v-else class="icon has-text-grey is-self-centered"><i class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
          </label>
          <a v-else-if="askRemoveLine" class="page-header-btn is-small is-square tooltip is-tooltip-top"
             :disabled="true" data-tooltip="Lier un document">
            <span class="icon is-size-4"><i class="fal fa-link"></i></span>
          </a>
        </div>
        <div class="column is-narrow is-border-left" v-if="askRemoveLink">
          <a class="page-header-btn is-small is-danger is-striped" @click="removeLink">
            <span class="is-size-7">Confirmer suppression du document lié</span>
          </a>
        </div>
        <div class="column is-narrow is-border-left" v-if="askRemoveLink">
          <a class="page-header-btn is-small is-square tooltip is-tooltip-top"
             data-tooltip="Annuler suppression document lié" @click="cancelRemove">
            <i class="fal fa-times"></i>
          </a>
        </div>
        <div class="column is-narrow is-border-left" v-if="!askRemoveLine && (isAdmin || isSectorManager)">
          <a v-if="!askRemoveLink" class="page-header-btn is-small is-square tooltip is-tooltip-top"
             @click="askRemove('askRemoveLine')" data-tooltip="Supprimer la ligne">
            <span class="icon is-size-4"><i class="fal fa-trash-alt"></i></span>
          </a>
          <a v-else class="page-header-btn is-small is-square tooltip is-tooltip-top"
             :disabled="true" data-tooltip="Supprimer la ligne">
            <span class="icon is-size-4"><i class="fal fa-trash-alt"></i></span>
          </a>
        </div>
        <div class="column is-narrow is-border-left" v-if="askRemoveLine">
          <a class="page-header-btn is-small is-danger is-striped" @click="removeLine">
            <span class="is-size-7">Confirmer suppression de la ligne</span>
          </a>
        </div>
        <div class="column is-narrow is-border-left" v-if="askRemoveLine">
          <a class="page-header-btn is-small is-square tooltip is-tooltip-top"
             data-tooltip="Annuler suppression de la ligne" @click="cancelRemove">
            <i class="fal fa-times"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import { bus, EVENTS } from '@/services/bus/index.js'
  import { debounce } from 'lodash'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'DocumentListItem',
    data () {
      return {
        uploading: false,
        askRemoveLine: false,
        askRemoveLink: false
      }
    },
    props: {
      source: {
        type: Object,
        required: true
      },
      index: Number,
      allDocuments: Object,
      selectedRow: String,
      canDrag: {
        type: Boolean,
        default: true
      },
      openInput: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters(['isSeller', 'isExternal', 'isAdmin', 'isSectorManager']),
      ...mapState(['modal']),
      item () {
        return this.source
      },
      documentIsValid () {
        return this.item.document && this.item.document.path
      },
      isImage () {
        if (!this.item || !this.item.document || !this.item.document.path) return
        let ext = this.item.document.path.split('.')
        return /(jpg|png|jpeg|gif)/g.test(ext[ext.length - 1])
      }
    },
    watch: {
      selectedRow (v) {
        if (v !== 'document-' + this.index) {
          this.cancelRemove()
        }
      },
      modal ({ mode, params, results }) {
        if (results) {
          if (mode === 'DOCUMENTS_SELECTION' && results.from === this.item.value) {
            this.addDocumentTo(results)
            console.log(results)
          }
        }
      }
    },
    methods: {
      async processFile (event) {
        let file = event.target.files[0]
        let files = new FormData()
        files.append('file[]', file, file.name)
        this.uploading = true
        let document = null
        try {
          let res = await this.$fus.post({ data: files })
          document = res.data[0]
          document.fus_id = document.id
        } catch (e) {
          console.log(e)
        } finally {
          this.uploading = false
        }
        if (document) {
          this.addDocumentTo(document)
        }
      },
      updateItem () {
        this.$emit('update', this.item)
      },
      updateName: debounce(function () {
        this.updateItem()
      }, 500),
      askRemove (key) {
        this[key] = true
        this.toggleDisplayButtons()
      },
      cancelRemove () {
        this.askRemoveLine = false
        this.askRemoveLink = false
      },
      removeLink () {
        this.$set(this.item, 'document', null)
        this.updateItem()
        this.cancelRemove()
      },
      removeLine () {
        this.$emit('remove', this.index)
        this.cancelRemove()
      },
      openModalDocumentsSelection (from) {
        this.cancelRemove()
        let params = {
          title: 'Documents ADV',
          from,
          source: { ...this.allDocuments }
        }
        this.$store.commit('setModal', { mode: 'DOCUMENTS_SELECTION', params })
      },
      addDocumentTo (val) {
        if (val.document) {
          this.$set(this.item, 'document', val.document)
        } else {
          this.$set(this.item, 'document', val)
        }
        this.updateItem()
      },
      openPreview (selectedDocument) {
        if (this.isImage) {
          let link = document.createElement('a')
          link.href = selectedDocument.path
          link.target = '_blank'
          link.click()
        } else {
          let params = {
            source: selectedDocument
          }
          this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
        }
      },
      toggleDisplayButtons () {
        this.$emit('selectedRow', 'document-' + this.index)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/DocumentListItem.vue